import { useContext } from 'react';
// import Button from 'components/Button';

import Card from 'components/Card';
// import { ReactComponent as BookOpenIcon } from 'assets/icons/book-open.svg';
// import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
// import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import AppContext from 'context/app.context';
import Typography from 'components/Typography';

function ExamInformation() {
  const [app] = useContext(AppContext);

  return (
    <Card>
      <div>
        <Typography variant="subtitle1" className="font-normal" gutterBottom>
          Deskripsi Ujian
        </Typography>

        <Typography
          as="div"
          className="font-normal"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: app.des_ujian }}
        />
      </div>
    </Card>
  );
}

export default ExamInformation;
